import Vue from 'vue';

Vue.component('tax-index', () =>
    import(/* webpackChunkName: 'tax-index' */ './tax-index'),
);
